module.exports = __webpack_public_path__ + "static/media/gal-9.92758fee.jpeg";